import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.function.name";
import _get from "lodash/get";
import React from 'react';
import PropTypes from 'prop-types';
import { ImpressionContext } from '@nerdwallet/analytics/react/impression';
import ApplyNow from '@nerdwallet/react-apply-now';

var ApplyNowWrapper = function ApplyNowWrapper(props) {
  var data = props.data,
      config = props.config,
      disabled = props.disabled,
      className = props.className;
  var product = data;

  var issuer = _get(product, config.name) || _get(product, config.provider_key);

  var href = _get(product, config.link_data_key);

  var id = _get(product, config.provider_id).toString();

  var isCC = _get(config, 'is_cc', false);

  return React.createElement(ImpressionContext.Consumer, null, function (impressionData) {
    return React.createElement(ApplyNow, {
      className: className,
      isCC: isCC,
      impressionId: impressionData ? impressionData.impressionId : null,
      id: id,
      productId: id,
      productLocation: config.link_type || '',
      linkType: config.link_type,
      vertical: config.product_topic,
      productSlug: _get(product, config.cc_slug || config.provider_key),
      offerVersionId: _get(product, config.offerVersionId),
      issuer: issuer,
      text: config.buttonText,
      icon: config.iconType,
      showIcon: config.show_icon,
      link: href,
      disabled: disabled,
      disableAnnotation: config.disableAnnotation,
      finishType: config.finish_type,
      monetizable: config.monetizable
    });
  });
};

ApplyNowWrapper.displayName = 'ApplyNowWrapper';
ApplyNowWrapper.propTypes = {
  data: PropTypes.object,
  config: PropTypes.shape({
    // the path to the apply link in the data object
    link_data_key: PropTypes.string,
    // the path to the issuer name in the data object
    name: PropTypes.string,
    // the path to the product slug in the data object
    provider_key: PropTypes.string,
    // the path to the product ID in the data object
    provider_id: PropTypes.string,
    // the vertical
    product_topic: PropTypes.string,
    // the path to the product slug in the data object
    cc_slug: PropTypes.string,
    // toggle that controls whether or not CC-specific impression events are fired
    is_cc: PropTypes.bool,
    offerVersionId: PropTypes.string,
    // the text for the apply now button
    buttonText: PropTypes.string,
    // the icon for the ApplyNow button, if you would like to use a custom icon
    iconType: PropTypes.node,
    // allows toggling the default lock icon on and off
    show_icon: PropTypes.bool,
    // disables the `on x's secure website` text when true
    disableAnnotation: PropTypes.bool,
    // the specific UX control type for this ApplyNow
    // see https://github.com/NerdWallet/react-components/blob/master/components/apply-now/src/link-type.js for more detail
    link_type: PropTypes.string,
    // identifies the nature of 'funnel completion'
    // see https://github.com/NerdWallet/react-components/blob/master/components/apply-now/src/finish-type.js for more detail
    finish_type: PropTypes.string,
    // whether we expect a click through this button to generate revenue
    // see https://github.com/NerdWallet/react-components/blob/master/components/apply-now/src/monetizable.js for more detail
    monetizable: PropTypes.string
  }),
  disabled: PropTypes.bool,
  className: PropTypes.string
};
export default ApplyNowWrapper;